import { AbstractControl, ValidatorFn } from '@angular/forms';

export function notIncludedIn(arr: Array<any>): ValidatorFn {
  return (control: AbstractControl) => {
    return arr.indexOf(control.value) === -1 && control.value
      ? { notIncludedIn: true }
      : null;
  };
}
